// scripts.js
import { showToast, showGlobalPreloader, hideGlobalPreloader, get_parsed_jwt_identity } from "./utils.js";

// Global flag to prevent typewriter duplication
if (window.typewriterRunning === undefined) {
  window.typewriterRunning = false;
}

document.addEventListener("DOMContentLoaded", () => {
  const adminMenuButton = document.getElementById("adminMenuButton");
  const adminMenuOptions = document.getElementById("adminMenuOptions");

  if (adminMenuButton) {
    // Only run admin menu logic if the button exists
    updateAdminMenu();
    if (adminMenuOptions) {
      // Ensure adminMenuOptions also exists before adding listener
      adminMenuButton.addEventListener("click", () => {
        if (
          adminMenuOptions.style.display === "none" ||
          adminMenuOptions.style.display === ""
        ) {
          adminMenuOptions.style.display = "block";
        } else {
          adminMenuOptions.style.display = "none";
        }
      });
    }
  }

  if (window.location.pathname.endsWith("pricing.html")) {
    fetchAndDisplayCurrentSubscription();

    const currentPlanInfoDiv = document.getElementById("current-plan-info");
    currentPlanInfoDiv.addEventListener("click", async (e) => {
      if (e.target.classList.contains("btn-cancel-subscription")) {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
          showToast("Please log in to cancel subscription.", "error");
          setTimeout(() => {
            window.location.href = "login.html";
          }, 2000);
          return;
        }

        showConfirmationDialog(
          "Are you sure you want to cancel your subscription?",
          async (confirmed) => {
            if (confirmed) {
              showGlobalPreloader("Cancelling subscription...");
              try {
                const cancelResponse = await fetch("/api/billing/cancel", {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                });
                const cancelData = await cancelResponse.json();
                if (cancelResponse.ok) {
                  showToast("Subscription canceled successfully!", "success");
                  setTimeout(() => {
                    location.reload();
                  }, 2000);
                } else {
                  let errorMessage =
                    "An unknown error occurred during cancellation.";
                  if (cancelData && cancelData.error) {
                    errorMessage = cancelData.error;
                  } else if (cancelResponse.status) {
                    errorMessage = `Error: ${cancelResponse.status} ${cancelResponse.statusText || ""}`;
                  }
                  showToast(`Cancellation failed: ${errorMessage}`, "error");
                }
              } catch {
                showToast(
                  "An error occurred during cancellation. Please try again.",
                  "error",
                );
              } finally {
                hideGlobalPreloader();
              }
            }
          },
        );
      }
    });

    const subscribeButtons = document.querySelectorAll(".btn-subscribe");
    subscribeButtons.forEach((button) => {
      button.addEventListener("click", async (e) => {
        const planId = e.target.dataset.planId;
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
          showToast("Please log in to subscribe.", "error");
          setTimeout(() => {
            window.location.href = "login.html";
          }, 2000);
          return;
        }

        try {
          showGlobalPreloader("Initiating subscription...");
          const response = await fetch("/api/subscriptions/subscribe", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({ plan_id: planId }),
          });

          let data;
          try {
            data = await response.json();
          } catch {
            data = await response.text();
          }

          if (response.ok) {
            hideGlobalPreloader(); // Hide preloader before opening Razorpay
            const options = {
              key: data.razorpay_key_id,
              amount: data.amount,
              currency: "INR",
              name: "LukaIN",
              description: `Subscription to ${planId} plan`,
              order_id: data.order_id,
              handler: async (response) => {
                showGlobalPreloader("Verifying payment...");
                const verifyResponse = await fetch(
                  "/api/billing/verify_payment",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify({
                      plan_id: planId,
                      payment_id: response.razorpay_payment_id,
                      order_id: response.razorpay_order_id,
                      signature: response.razorpay_signature,
                      amount: data.amount,
                    }),
                  },
                );

                const verifyData = await verifyResponse
                  .json()
                  .catch(() => verifyResponse.text());

                if (verifyResponse.ok) {
                  if (verifyData.access_token) {
                    localStorage.setItem(
                      "access_token",
                      verifyData.access_token,
                    );
                  }
                  showToast("Subscription successful!", "success");
                  setTimeout(() => {
                    location.reload();
                  }, 2000);
                } else {
                  let errorMessage =
                    "An unknown error occurred during verification.";
                  if (typeof verifyData === "string") {
                    errorMessage = verifyData;
                  } else if (verifyData && verifyData.error) {
                    errorMessage = verifyData.error;
                  } else if (verifyData && verifyData.msg) {
                    errorMessage = verifyData.msg;
                  }
                  showToast(`Subscription failed: ${errorMessage}`, "error");
                }
                hideGlobalPreloader();
              },
            };

            const rzp = new Razorpay(options);
            rzp.open();
          } else {
            let errorMessage = "An unknown error occurred.";
            if (typeof data === "string") {
              errorMessage = data;
            } else if (data && data.error) {
              errorMessage = data.error;
            } else if (data && data.msg) {
              errorMessage = data.msg;
            } else if (response.status) {
              errorMessage = `Error: ${response.status} ${response.statusText || ""}`;
            }
            showToast(`Subscription failed: ${errorMessage}`, "error");
            hideGlobalPreloader();
          }
        } catch {
          showToast(
            "An error occurred while subscribing. Please try again.",
            "error",
          );
          hideGlobalPreloader();
        }
      });
    });
  }
});

function updateAdminMenu() {
  const adminMenuContainer = document.getElementById("adminMenuContainer");
  const adminMenuOptions = document.getElementById("adminMenuOptions");
  const token = localStorage.getItem("access_token");
  if (!token) {
    if (adminMenuContainer) adminMenuContainer.style.display = "none";
    return;
  }
  let role = "";
  try {
    const payload = get_parsed_jwt_identity();
    if (payload && payload.user_data) {
      try {
        const userData = typeof payload.user_data === 'string' ? JSON.parse(payload.user_data) : payload.user_data;
        if (userData && userData.role) {
          role = userData.role;
        }
      } catch {
        role = "";
      }
    }
  } catch {
    role = "";
  }
  if (role === "admin" || role === "chairman") {
    if (adminMenuContainer) {
      adminMenuContainer.style.display = "inline-block";
    }
    if (adminMenuOptions) {
      adminMenuOptions.innerHTML = "";

      // Add User Management link
      const teacherManagementLink = document.createElement("a");
      teacherManagementLink.href = "member_management.html";
      teacherManagementLink.textContent = "User Management";
      teacherManagementLink.classList.add("nav-item");
      adminMenuOptions.appendChild(teacherManagementLink);

      // Add Timetable Management link
      const timetableManagementLink = document.createElement("a");
      timetableManagementLink.href = "timetable_management.html";
      timetableManagementLink.textContent = "Timetable Management";
      timetableManagementLink.classList.add("nav-item");
      adminMenuOptions.appendChild(timetableManagementLink);

      // Add Get Member Codes link
      const getTeacherCodesLink = document.createElement("a");
      getTeacherCodesLink.href = "get_member_codes.html";
      getTeacherCodesLink.textContent = "Get Member Codes";
      getTeacherCodesLink.classList.add("nav-item");
      adminMenuOptions.appendChild(getTeacherCodesLink);

      // Show Admin Approval link only for chairman
      if (role === "chairman") {
        const adminApprovalLink = document.createElement("a");
        adminApprovalLink.href = "admin_approval.html";
        adminApprovalLink.textContent = "Account Approval";
        adminApprovalLink.classList.add("nav-item");
        adminMenuOptions.appendChild(adminApprovalLink);

        const superAdminDashboardLink = document.createElement("a");
        superAdminDashboardLink.href = "superadmindashboard.html";
        superAdminDashboardLink.textContent = "Owner Dashboard";
        superAdminDashboardLink.classList.add("nav-item");
        adminMenuOptions.appendChild(superAdminDashboardLink);
      }
      // Show Deletion Approval link for both admin and chairman
      const deletionApprovalLink = document.createElement("a");
      deletionApprovalLink.href = "deletion_approval.html";
      deletionApprovalLink.textContent = "Account Deletion Approval";
      deletionApprovalLink.classList.add("nav-item");
      adminMenuOptions.appendChild(deletionApprovalLink);
    }
  } else {
    if (adminMenuContainer) adminMenuContainer.style.display = "none";
  }
}

// Function to fetch and display current subscription
async function fetchAndDisplayCurrentSubscription() {
  const currentPlanInfoDiv = document.getElementById("current-plan-info");
  if (!currentPlanInfoDiv) return;

  showGlobalPreloader("Loading subscription info...");
  const subscribeButtons = document.querySelectorAll(".btn-subscribe");
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) {
    currentPlanInfoDiv.innerHTML =
      "<p>Please log in to view your current plan.</p>";
    hideGlobalPreloader();
    return;
  }

  try {
    const response = await fetch("/subscriptions/subscription", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      const currentPlanId = data.plan_id;
      const currentPlanName =
        data.plan_id.charAt(0).toUpperCase() + data.plan_id.slice(1);
      currentPlanInfoDiv.innerHTML = `<p>Your current plan: <strong>${currentPlanName}</strong></p>`;

      // Disable buttons for current or lower plans
      subscribeButtons.forEach((button) => {
        const planId = button.dataset.planId;
        if (planId === currentPlanId) {
          button.textContent = "Current Plan";
          button.disabled = true;
          button.classList.add("btn-current-plan");
        } else if (
          (planId === "basic" && currentPlanId === "premium") ||
          (planId === "free" &&
            (currentPlanId === "basic" || currentPlanId === "premium"))
        ) {
          button.disabled = true;
          button.classList.add("btn-disabled");
        }
      });

      // Add cancel subscription button if not free
      if (currentPlanId !== "free") {
        const cancelButton = document.createElement("button");
        cancelButton.textContent = "Cancel Subscription";
        cancelButton.classList.add("btn-primary", "btn-cancel-subscription");
        currentPlanInfoDiv.appendChild(cancelButton);
      }
    } else if (response.status === 404) {
      // No active subscription found, so we can allow the user to subscribe to any plan.
      currentPlanInfoDiv.innerHTML =
        "<p>You do not have an active subscription.</p>";
    } else {
      // Other errors fetching subscription
      currentPlanInfoDiv.innerHTML = "<p>Error loading current plan.</p>";
      /* console.error(
        "Error fetching current subscription:",
        response.status,
        response.statusText,
      ); */
    }
  } catch {
    /* console.error("Error fetching current subscription:", error); */
    currentPlanInfoDiv.innerHTML =
      "<p>An error occurred while loading current plan.</p>";
  } finally {
    hideGlobalPreloader();
  }
}

function showConfirmationDialog(message, callback) {
  const confirmationDialog = document.getElementById("confirmation-dialog");
  document.querySelector("#confirmation-dialog p").textContent = message;
  confirmationDialog.style.display = "flex";

  const confirmYesButton = document.getElementById("confirm-yes");
  const confirmNoButton = document.getElementById("confirm-no");

  confirmYesButton.onclick = () => {
    confirmationDialog.style.display = "none";
    callback(true);
  };

  confirmNoButton.onclick = () => {
    confirmationDialog.style.display = "none";
    callback(false);
  };
}
